import { useState, type FormEvent } from 'react';

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setFormError('');
      return;
    }

    const message = (form.querySelector('textarea[name="message"]') as HTMLTextAreaElement)?.value || '';
    if (message.length > 500) {
      setFormError('留言内容不能超过500字');
      setStatus('error');
      return;
    }

    setStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9svd9tlbrt1qcgajau0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setFormError('');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(serverMsg);
        }
        setStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <div className="p-8 rounded-xl bg-background-100">
      <h3 className="text-lg font-semibold text-foreground-900 mb-6">发送消息</h3>
      <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
            您的姓名
          </label>
          <input
            id="contact-name"
            name="name"
            type="text"
            required
            className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
            电子邮箱
          </label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
            placeholder="请输入您的电子邮箱"
          />
        </div>
        <div>
          <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
            主题
          </label>
          <input
            id="contact-subject"
            name="subject"
            type="text"
            required
            className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
            placeholder="请输入主题"
          />
        </div>
        <div>
          <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
            留言内容
          </label>
          <textarea
            id="contact-message"
            name="message"
            required
            maxLength={500}
            rows={4}
            className="w-full px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200 resize-none"
            placeholder="请描述您的问题或建议（500字以内）"
          ></textarea>
        </div>
        <div className="honeypot-field">
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
        </div>
        <button
          type="submit"
          disabled={status === 'loading'}
          className="w-full py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          {status === 'loading' ? '发送中...' : '发送消息'}
        </button>
        {status === 'success' && (
          <p className="text-sm text-center text-green-600 font-medium">消息发送成功！我们会尽快回复您。</p>
        )}
        {status === 'error' && formError && (
          <p className="text-sm text-center text-red-500 font-medium">{formError}</p>
        )}
      </form>
    </div>
  );
}